import { pageData as types } from '../mutation-types';

export default {
    namespaced: true,
    state: {
        isLoading: false,
        isMask: false,
        isFirstEdit: true,
    },
    // getters,
    actions: {
        setIsLoading({ commit }, val) {
            commit(types.setIsLoading, val);
        },
        setIsFirstEdit({ commit }, val) {
            commit(types.setIsFirstEdit, val);
        },
    },
    mutations: {
        [types.setIsLoading]: (state, data) => {
            state.isLoading = data;
        },
        [types.setIsFirstEdit]: (state, data) => {
            state.isFirstEdit = data;
        },
    },
};
